module.exports = __webpack_public_path__ + "img/japanese-“not-free-of-charge”-button.7a466af1.png";